import React, {useEffect, useState} from "react";
import axios from "axios";
import {Alert, Modal, Spinner, Table} from "react-bootstrap";

function quantity(value) {
    return new Intl.NumberFormat("de-DE", {maximumFractionDigits: 3}).format(Number(value));
}

export default function ReservationModal({show, onHide, artikelnummer, weclappBaseUrl}) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        if (!show || !artikelnummer) return undefined;
        const controller = new AbortController();
        setLoading(true);
        setError(null);
        axios.get("/stock/overview/reservations", {params: {artikelnummer}, signal: controller.signal})
            .then(({data}) => setRows(Array.isArray(data?.rows) ? data.rows : []))
            .catch((e) => {
                if (!axios.isCancel(e)) setError(e.response?.data?.message || e.message || "Die Reservierungen konnten nicht geladen werden.");
            })
            .finally(() => setLoading(false));
        return () => controller.abort();
    }, [show, artikelnummer]);

    return <Modal show={show} onHide={onHide} centered size="xl" scrollable>
        <Modal.Header closeButton className="px-4 py-3"><Modal.Title className="fs-5 fw-semibold">Reservierte Bestände: {artikelnummer}</Modal.Title></Modal.Header>
        <Modal.Body className="p-4">
            {loading && <div className="text-center text-muted py-4"><Spinner animation="border" size="sm" className="me-2" />Reservierungen werden geladen…</div>}
            {!loading && error && <Alert variant="danger">{error}</Alert>}
            {!loading && !error && rows.length === 0 && <Alert variant="light" className="border mb-0">Für diesen Artikel sind keine offenen Reservierungen vorhanden.</Alert>}
            {!loading && !error && rows.length > 0 && <div className="border rounded-3 overflow-hidden">
                <div className="table-responsive">
                    <Table hover className="mb-0 align-middle small" style={{minWidth: "900px"}}>
                        <thead className="table-light"><tr>
                            <th className="px-3 py-2 text-uppercase text-muted small fw-semibold">Auftrag</th>
                            <th className="px-3 py-2 text-uppercase text-muted small fw-semibold text-nowrap">Auftragsdatum</th>
                            <th className="px-3 py-2 text-uppercase text-muted small fw-semibold">Kunde</th>
                            <th className="px-3 py-2 text-uppercase text-muted small fw-semibold">Verantwortlich</th>
                            <th className="px-3 py-2 text-uppercase text-muted small fw-semibold">Auftragsstatus</th>
                            <th className="px-3 py-2 text-uppercase text-muted small fw-semibold text-end text-nowrap">Gebundene Menge</th>
                        </tr></thead>
                        <tbody>{rows.map((row) => <tr key={row.id}>
                            <td className="px-3 py-2 text-nowrap"><a className="fw-semibold" href={`${weclappBaseUrl}app/sales-order/${row.weclapp_order_id}`} target="_blank" rel="noreferrer">{row.order_number || row.weclapp_order_id}</a></td>
                            <td className="px-3 py-2 text-nowrap text-secondary">{row.order_date || "–"}</td>
                            <td className="px-3 py-2">{row.customer_name || "–"}</td>
                            <td className="px-3 py-2">{row.responsible_user_name || "–"}</td>
                            <td className="px-3 py-2" title={row.order_status}>{row.order_status_label || row.order_status}</td>
                            <td className="px-3 py-2 text-end text-nowrap fw-semibold">{quantity(row.quantity_open)}</td>
                        </tr>)}</tbody>
                    </Table>
                </div>
            </div>}
        </Modal.Body>
    </Modal>;
}
